/** Angular Imports */
import { AsyncValidatorFn, FormBuilder, ValidatorFn } from '@angular/forms';

/** Interface Imports */
import { FormField } from '@features/users/interfaces';

/**
 * A form builder which takes the instance of the FormBuilder and the constant fields to build your FormGroup from
 * @param fb  FormBuilder instance
 * @param fields An array of type FormField
 * @param validators Optional validators to be applied to the FormGroup
 * @param {{ field: string, asyncValidator: AsyncValidatorFn }[]} asyncValidators Optional async validators to be applied to the FormGroup
 * @returns FormGroup instance
 */
export const formBuilder = (
    fb: FormBuilder,
    fields: FormField[],
    validators?: ValidatorFn[],
    asyncValidators?: { field: string; asyncValidator: AsyncValidatorFn }[],
) => {
    return fb.group(
        fields.reduce(
            (acc, field) => {
                const initialState = field.disabled ? { value: '', disabled: true } : '';
                acc[field.name] = [
                    initialState,
                    field.validators ?? [], // sync validators (2nd slot)
                    asyncValidators?.find((v) => v.field === field.name)?.asyncValidator
                        ? [asyncValidators.find((v) => v.field === field.name)!.asyncValidator]
                        : [], // async validators (3rd slot)
                ];
                return acc;
            },
            {} as Record<string, any>,
        ),
        { validators: validators ?? [] },
    );
};
